import { extractMessageFromError } from '../../infra/adapters/luminara/common/ErrorUtil';
import { MyAppointmentsAsClientDTO } from '../../infra/adapters/luminara/booking/dto/my-appointments-as-client.dto';
import { Booking } from '../../core/models/booking';

export interface ClientBookedAppointmentsState {
  clientBookedAppointments?: MyAppointmentsAsClientDTO;
  loadingDataError?: string;
  showCancelationConfirmModal: boolean;
  showBookingCancelledSuccessModal: boolean;
  bookingToBeCancelled?: Booking;
}

export const initialClientBookedAppointmentsState = () =>
  ({
    showCancelationConfirmModal: false,
    showBookingCancelledSuccessModal: false,
  } as ClientBookedAppointmentsState);

export interface ClientBookedAppointmentsAction {
  type:
    | 'LOAD_CLIENT_BOOKED_APPOINTMENTS_SUCCESS'
    | 'LOAD_CLIENT_BOOKED_APPOINTMENTS_FAILURE'
    | 'BOOKING_CANCELLED_BY_CLIENT_SUCCESS'
    | 'BOOKING_CANCELLED_BY_CLIENT_FAILURE'
    | 'SHOW_CANCELATION_CONFIRMATION_MODAL'
    | 'HIDE_CANCELATION_CONFIRMATION_MODAL'
    | 'HIDE_BOOKING_CANCELLED_SUCESSFULLY_MODAL';
  payload?: any;
}

const clientBookedAppointmentsReducer = (
  state: ClientBookedAppointmentsState = initialClientBookedAppointmentsState(),
  action: ClientBookedAppointmentsAction
): ClientBookedAppointmentsState => {
  switch (action.type) {
    case 'LOAD_CLIENT_BOOKED_APPOINTMENTS_SUCCESS':
      return {
        ...state,
        clientBookedAppointments: action.payload,
      };
    case 'LOAD_CLIENT_BOOKED_APPOINTMENTS_FAILURE':
      return { ...state, loadingDataError: extractMessageFromError(action.payload) };
    case 'BOOKING_CANCELLED_BY_CLIENT_SUCCESS': {
      const bookingId = action.payload;
      return {
        ...state,
        showBookingCancelledSuccessModal: true,
        showCancelationConfirmModal: false,
        bookingToBeCancelled: undefined,
        clientBookedAppointments: {
          upcomingBookings: state.clientBookedAppointments?.upcomingBookings?.filter((it) => it.id !== bookingId),
          cancelledByClientBookings: state.clientBookedAppointments?.cancelledByClientBookings,
          cancelledByHealerBookings: state.clientBookedAppointments?.cancelledByHealerBookings,
          pastBookings: state.clientBookedAppointments?.pastBookings,
        },
      };
    }

    case 'BOOKING_CANCELLED_BY_CLIENT_FAILURE': {
      return {
        ...state,
        loadingDataError: extractMessageFromError(action.payload),
        showBookingCancelledSuccessModal: false,
        showCancelationConfirmModal: false,
        bookingToBeCancelled: undefined,
      };
    }

    case 'SHOW_CANCELATION_CONFIRMATION_MODAL': {
      const bookingId = action.payload;
      const booking = state.clientBookedAppointments?.upcomingBookings?.find((it) => it.id === bookingId);

      return { ...state, showCancelationConfirmModal: true, bookingToBeCancelled: booking };
    }

    case 'HIDE_CANCELATION_CONFIRMATION_MODAL': {
      return {
        ...state,
        showBookingCancelledSuccessModal: false,
        showCancelationConfirmModal: false,
        bookingToBeCancelled: undefined,
      };
    }

    case 'HIDE_BOOKING_CANCELLED_SUCESSFULLY_MODAL': {
      return {
        ...state,
        showBookingCancelledSuccessModal: false,
        showCancelationConfirmModal: false,
        bookingToBeCancelled: undefined,
      };
    }
    default:
      return state;
  }
};

export default clientBookedAppointmentsReducer;
